import Axios, { AxiosResponse } from 'axios';
import { config } from '../../../config';

// eslint-disable-next-line import/prefer-default-export
export const getCommentary = async (
  eventId: number,
  lastCommentId: number,
) => {
  const { data }: AxiosResponse = await Axios.get(`${config.apiUrl}/race-hub/commentary/${eventId}`, {
    params: {
      lastCommentId,
    },
  });

  return data;
};
